export const APIResult = {
  SUCCESS: 1,
  FAILED: 0,
  TIMEOUT: -1,
};
